"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkKind = exports.ApexSyntaxKind = void 0;
var ApexSyntaxKind;
(function (ApexSyntaxKind) {
    ApexSyntaxKind[ApexSyntaxKind["None"] = 0] = "None";
    ApexSyntaxKind[ApexSyntaxKind["SyntaxKeyword"] = 1] = "SyntaxKeyword";
    ApexSyntaxKind[ApexSyntaxKind["SyntaxType"] = 2] = "SyntaxType";
    ApexSyntaxKind[ApexSyntaxKind["SyntaxNumericLiteral"] = 3] = "SyntaxNumericLiteral";
    ApexSyntaxKind[ApexSyntaxKind["SyntaxStringLiteral"] = 4] = "SyntaxStringLiteral";
    ApexSyntaxKind[ApexSyntaxKind["SyntaxSoqlLiteral"] = 5] = "SyntaxSoqlLiteral";
    ApexSyntaxKind[ApexSyntaxKind["SyntaxComments"] = 6] = "SyntaxComments";
})(ApexSyntaxKind || (exports.ApexSyntaxKind = ApexSyntaxKind = {}));
var LinkKind;
(function (LinkKind) {
    LinkKind[LinkKind["SfdcEntity"] = 7] = "SfdcEntity";
    LinkKind[LinkKind["SfdcField"] = 8] = "SfdcField";
    LinkKind[LinkKind["SfdcApexClass"] = 9] = "SfdcApexClass";
})(LinkKind || (exports.LinkKind = LinkKind = {}));
//# sourceMappingURL=PeriscopeSfApexClass.js.map